import type ApplicationModel from 'components/framework/ApplicationModel';

export interface AtRiskFlaggable {
  flagAsAtRisk(
    manualRiskComment: string | null,
    options?: any
  ): Promise<boolean>;
}

export function AtRiskFlaggable(originalClass: {
  new (...args: any[]): ApplicationModel;
}): any {
  return class extends originalClass implements AtRiskFlaggable {
    async flagAsAtRisk(
      manualRiskComment: string | null = null,
      options: any = {}
    ) {
      const { __reactivelyUpdate = true } = options;
      return this.update(
        { manualRiskComment },
        { args: { __reactivelyUpdate } }
      );
    }
  };
}
